import React, { useState, useEffect } from 'react';
import { Typography, Grid, Paper, Button, Divider } from '@mui/material';
import { useNavigate, useParams } from 'react-router';
import { getApi } from 'views/services/api';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SingleInvoiceView = () => {
  const [invoiceData, setInvoiceData] = useState({});
  const [itemsData, setitemsData] = useState([]);
  const [isPrinted, setIsPrinted] = useState(false);
  const hotel = JSON.parse(localStorage.getItem('hotelData'));
  const currency = hotel?.currency || 'USD';
  const params = useParams();
  const reservationId = params.id;
  const navigate = useNavigate();

  const fetchSingleBillData = async () => {
    try {
      const response = await getApi(`api/singleinvoice/view/${reservationId}`);
      console.log('this is the single invoice ==>', response);

      setInvoiceData(response?.data?.InvoiceData[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchSingleBillData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservationId]);

  const handlePrint = () => {
    setIsPrinted(true);
    window.print();
  };

  const currentDate = new Date().toLocaleDateString();

  // // function for fetching all the restaurant items data from the db
  const fetchitemsData = async () => {
    try {
      const response = await getApi(`api/reservation/getfooditems/${reservationId}`);
      setitemsData(response?.data?.foodItemsData[0]?.foodItems);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchitemsData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid container justifyContent="center" sx={{ padding: '20px' }}>
      <Grid item xs={12}>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          sx={{ marginLeft: 2, color: '#673ab7', borderColor: '#673ab7', position: 'absolute', right: 10 }}
          onClick={() => navigate(-1)}
          // className={`back-button ${isPrinted ? 'hidden' : ''}`}
          className="back-button"
        >
          Back
        </Button>
      </Grid>

      <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Paper elevation={3} sx={{ padding: '20px', maxWidth: '800px', marginTop: '12px' }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h3" align="center" gutterBottom>
                Food + Room Invoice
              </Typography>
              <Typography variant="subtitle1" align="center" gutterBottom>
                Date: {currentDate}
              </Typography>
              <Divider />
            </Grid>

            {/* Hotel Details */}
            <Grid item xs={12} md={4}>
              <Typography variant="h4" gutterBottom>
                Hotel Details
              </Typography>
              <Typography variant="subtitle1">{hotel.name}</Typography>
              <Typography variant="subtitle1">{hotel.address}</Typography>
              <Typography variant="subtitle1">{invoiceData?.gstNumber}</Typography>
              <Typography variant="subtitle1">{invoiceData?.invoiceNumber}</Typography>
            </Grid>

            {/* Customer Details */}
            <Grid item xs={12} md={4}>
              <Typography variant="h4" gutterBottom>
                Customer Details
              </Typography>
              <Typography variant="subtitle1">{invoiceData?.name}</Typography>
              <Typography variant="subtitle1">{invoiceData?.address}</Typography>
              <Typography variant="subtitle1">{invoiceData?.customerPhoneNumber}</Typography>
              {invoiceData.haveGST && <Typography variant="subtitle1">{invoiceData?.gstNumber}</Typography>}
            </Grid>

            {/* Check-in/Check-out Times and Payment Method */}
            <Grid item xs={12} md={4}>
              {invoiceData?.FinalCheckInTime && (
                <Typography>
                  <b>Customer Check-In Time: </b>
                  {invoiceData?.FinalCheckInTime}
                </Typography>
              )}
              {invoiceData?.FinalCheckOutTime && (
                <Typography>
                  <b>Customer Check-Out Time: </b>
                  {invoiceData?.FinalCheckOutTime}
                </Typography>
              )}
              {invoiceData.paymentMethod && (
                <Typography>
                  <b>Payment Method: </b>
                  {invoiceData?.paymentMethod}
                </Typography>
              )}
            </Grid>

            <hr />
            <Grid item xs={12} md={12}>
              <Typography variant="h4" gutterBottom>
                <b>Room Details : </b>
              </Typography>
            </Grid>
            <TableContainer component={Paper} sx={{ margin: '20px', marginLeft: '32px' }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Description</b>
                    </TableCell>

                    <TableCell>
                      <b>Amount</b>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {invoiceData?.roomRent ? (
                    <TableRow>
                      <TableCell>
                        <b>Room Rent</b>
                      </TableCell>
                      <TableCell>
                        <b>
                          {currency} {invoiceData.roomRent}
                        </b>
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  {invoiceData?.advanceAmount ? (
                    <TableRow>
                      <TableCell>
                        <b>Advance Amount</b>
                      </TableCell>

                      <TableCell>
                        <b>
                          {currency} {invoiceData.advanceAmount}
                        </b>
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow>
                    <TableCell>
                      <b>Discount</b>
                    </TableCell>

                    <TableCell>
                      <b>
                        {currency} {invoiceData?.roomDiscount ? invoiceData.roomDiscount : 0}
                      </b>
                    </TableCell>
                  </TableRow>
                  {invoiceData?.haveRoomGst ? (
                    <TableRow>
                      <TableCell>
                        <b>GST Amount</b>
                      </TableCell>

                      <TableCell>
                        <b>
                          {currency} {invoiceData.roomGstAmount}{' '}
                        </b>
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  {invoiceData?.totalRoomAmount ? (
                    <TableRow>
                      <TableCell>
                        <b>Total Amount {invoiceData.haveRoomGst ? '( with GST)' : ''}</b>
                      </TableCell>

                      <TableCell>
                        <b>
                          {currency} {invoiceData.totalRoomAmount}
                        </b>
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* table for food ---------------- */}
            <hr />
            <Grid item xs={12} md={12}>
              <Typography variant="h4" gutterBottom>
                <b>Food Details : </b>
              </Typography>
            </Grid>
            <TableContainer component={Paper} sx={{ margin: '20px', marginLeft: '32px' }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Description</b>
                    </TableCell>
                    <>
                      <TableCell>
                        <b>Price</b>
                      </TableCell>
                      <TableCell>
                        <b>Quantity</b>
                      </TableCell>
                    </>

                    <TableCell>
                      <b>Amount</b>
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {itemsData?.map((foodItem) => (
                    <TableRow key={foodItem._id}>
                      <TableCell>
                        <b>{foodItem.name}</b>
                      </TableCell>
                      <TableCell>
                        <b>{foodItem.price}</b>
                      </TableCell>
                      <TableCell>
                        <b>{foodItem.quantity}</b>
                      </TableCell>
                      <TableCell>
                        <b>
                          {currency} {foodItem.totalAmountFood}
                        </b>
                      </TableCell>
                    </TableRow>
                  ))}
                  {invoiceData?.foodAmount ? (
                    <TableRow>
                      <TableCell>
                        <b>Food Amount</b>
                      </TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>
                        <b>
                          {currency} {invoiceData.foodAmount}
                        </b>
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  <TableRow>
                    <TableCell>
                      <b>Discount</b>
                    </TableCell>
                    <TableCell>-</TableCell>
                    <TableCell>-</TableCell>
                    <TableCell>
                      <b>
                        {currency} {invoiceData?.foodDiscount ? invoiceData.foodDiscount : 0}
                      </b>
                    </TableCell>
                  </TableRow>
                  {invoiceData?.haveFoodGst ? (
                    <TableRow>
                      <TableCell>
                        <b>GST Amount</b>
                      </TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>-</TableCell>

                      <TableCell>
                        <b>
                          {currency} {invoiceData.foodGstAmount}{' '}
                        </b>
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}

                  {invoiceData?.totalFoodAmount ? (
                    <TableRow>
                      <TableCell>
                        <b>Total Amount {invoiceData.haveFoodGst ? '( with GST)' : ''}</b>
                      </TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>-</TableCell>
                      <TableCell>
                        <b>
                          {currency} {invoiceData.totalFoodAmount}
                        </b>
                      </TableCell>
                    </TableRow>
                  ) : (
                    ''
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Grid item xs={12} md={12}>
              <Typography>
                <span>
                  <b>Total Amount ( Room + Food ) : </b>
                </span>
                {currency} {invoiceData?.totalFoodAndRoomAmount}
              </Typography>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography sx={{ textAlign: 'end', fontSize: '15px', marginRight: '10px' }} variant="subtitle1">
                Signature
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <style>
        {`
    @media print {
      .print-button,
      .back-button{
        display: none;
      }
    }
  `}
      </style>
      <Grid item xs={12} md={1} sx={{ marginTop: '20px' }} className="print-button">
        <Button variant="contained" onClick={handlePrint} fullWidth>
          Print
        </Button>
      </Grid>
    </Grid>
  );
};

export default SingleInvoiceView;
